// This build's id, for the update gate's reload marker (shell/UpdateGate.tsx, update-policy.ts).
// The build writes it into index.html (`<meta name="valyrio-build">`, vite.config.ts buildIdMeta):
// a hash of the chunk names (content-hashed) and the precached data files. It is kept out of the
// JS on purpose: a value that changes with every build inside the entry chunk changed that chunk's
// name and so the name of every chunk importing it — each deploy re-downloaded ~550 KB of
// unchanged code (docs/audit/performance.md). The page shell is precached with the chunks it
// names, so the meta always belongs to the code that runs.
export function buildId(): string {
  try {
    return document.querySelector('meta[name="valyrio-build"]')?.getAttribute('content') || 'dev';
  } catch {
    return 'dev';
  }
}
